"use client";

import { useState } from "react";
import ArticleCard, { ArticleCardData } from "@/components/ArticleCard";

const PAGE_SIZE = 12;

/**
 * Client-side "load more" grid for the /blog index. The server sends the
 * full article list (already topic-filtered and sorted); this component
 * renders the first PAGE_SIZE cards and reveals another batch each time
 * the reader clicks "Load more articles". Keeps the initial paint light
 * without hiding posts behind pagination URLs.
 */
export default function BlogGrid({ items }: { items: ArticleCardData[] }) {
  const [visible, setVisible] = useState(PAGE_SIZE);
  const shown = items.slice(0, visible);
  const remaining = items.length - shown.length;

  return (
    <>
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {shown.map((a) => (
          <ArticleCard key={a.slug} article={a} />
        ))}
      </div>

      {remaining > 0 && (
        <div className="mt-10 flex justify-center">
          <button
            type="button"
            onClick={() => setVisible((v) => v + PAGE_SIZE)}
            className="rounded-full border border-[#120F30] px-8 py-3 text-sm font-semibold text-[#120F30] transition hover:bg-[#120F30] hover:text-white"
          >
            Load more articles ({remaining})
          </button>
        </div>
      )}
    </>
  );
}
